import React from 'react';
import { Link } from 'react-router-dom';
import { User, MapPin, Phone, Mail, LogOut, ShoppingBag } from 'lucide-react';
import './Account.css';

function Account({ customer, setCustomer }) {
  if (!customer) {
    return (
      <div className="account-page">
        <div className="account-card">
          <h2>Please sign in</h2>
          <Link to="/login" className="btn btn-gold">Sign In</Link>
        </div>
      </div>
    );
  }

  const handleLogout = () => {
    setCustomer(null);
  };

  return (
    <div className="account-page">
      <section className="account-header">
        <div className="account-avatar">{customer.name.charAt(0)}</div>
        <h1>{customer.name}</h1>
        <p>{customer.email}</p>
      </section>

      <div className="account-content">
        <div className="account-section">
          <h3><User size={18} /> Profile Information</h3>
          <div className="info-grid">
            <div className="info-item">
              <Mail size={16} />
              <div>
                <span className="info-label">Email</span>
                <span className="info-value">{customer.email}</span>
              </div>
            </div>
            <div className="info-item">
              <Phone size={16} />
              <div>
                <span className="info-label">Phone</span>
                <span className="info-value">{customer.phone}</span>
              </div>
            </div>
            <div className="info-item">
              <MapPin size={16} />
              <div>
                <span className="info-label">Address</span>
                <span className="info-value">{customer.address}, {customer.city}, {customer.country}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="account-actions">
          <Link to="/collection" className="btn btn-gold">
            <ShoppingBag size={16} /> Continue Shopping
          </Link>
          <button className="btn logout-btn" onClick={handleLogout}>
            <LogOut size={16} /> Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}

export default Account;
